import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import AppLoader from 'components/Loader';
import './Browse.css';
import { useDispatch, useSelector } from 'react-redux';
import { getDashboardsBySite, sendDashboardHit } from 'redux/thunks/dashboard';
import { addFavoriteDashboard, removeFavoriteDashboard } from 'redux/thunks/user';
import { resetGettingDashboardsBySite } from 'redux/actions/dashboard';
import {
    FormControl,
    InputLabel,
    Select,
    TextField,
    InputAdornment,
    TableContainer,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Tooltip,
    Paper,
    TableHead,
    makeStyles,
    withStyles,
    Typography,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import PersonIcon from '@material-ui/icons/PersonOutline';
import PeopleIcon from '@material-ui/icons/PeopleOutline';
import useDebounce from 'utilities/useDebounce';
import { useCallback } from 'react';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import FavoriteIcon from '@material-ui/icons/Favorite';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const useStyles = makeStyles({
    searchRoot: {
        marginTop: '16px',
    },
});

const Browse = () => {
    const siteIds = useSelector((state) => state.site.siteIds);
    const siteIdsLoading = useSelector((state) => state.site.adminSiteIdsLoading);
    const authenticated = useSelector((state) => state.user.authenticated);
    const email = useSelector((state) => state.user.email);
    const userName = useSelector((state) => state.user.userName);
    const isMobile = useSelector((state) => state.site.showMobile);
    const dashboard = useSelector((state) => state.dashboard);
    const favoriteDashboards = useSelector((state) => state.user.favoriteUserDashboards);
    const favoriteDashboardsLoading = useSelector((state) => state.user.favoriteDashboardsLoading);

    const dispatch = useDispatch();

    const [site, set_site] = useState('');
    const [mine] = useState('all');
    const [dashboards, setDashboards] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory();
    const classes = useStyles();
    const debouncedSearchTerm = useDebounce(searchTerm, 500);
    const previousSearchTerm = useRef('');

    const previousSelectedSiteIdKey = 'previousSelectedSiteId';
    const previousSearchTermKey = 'previousSearchTerm';

    const [favdashs, setFavdashs] = useState(dashboard.dashboards);

    const setFavorite = (index, val) => {
        let dashs = [...dashboard.dashboards];
        dashs[index].favorite = val;
        setFavdashs(dashs);
    };

    const openDashboard = (dashboard) => {
        dispatch(sendDashboardHit({
            siteId: dashboard.siteId,
            dashboardId: dashboard.dashboardId,
            history
        }));
    }

    const handleUpdateFavoriteDashboard = (index, isFavorite) => {
        if (isFavorite) {
            //need to make/get favorite dashboad obj
            let dashboardToFav = dashboard.dashboards[index];
            delete dashboardToFav.info;
            delete dashboardToFav.links;
            delete dashboardToFav.favorites;
            dispatch(addFavoriteDashboard(dashboardToFav)).then(() => {
                const favDashboardId = dashboard.dashboards[index].dashboardId;
                if (favoriteDashboards.filter((e) => e.dashboardId === favDashboardId).length > 0) {
                    setFavorite(index, true);
                }
            });
        } else {
            dispatch(removeFavoriteDashboard(dashboard.dashboards[index].dashboardId)).then(() => {
                const unFavDashboardId = dashboard.dashboards[index].dashboardId;
                if (favoriteDashboards.filter((e) => e.dashboardId === unFavDashboardId).length === 0) {
                    setFavorite(index, false);
                }
            });
        }
    };

    // Leaving the toggle code here due the potential of bringing back the 'all/mine' toggle
    // const handleToggle = () => {
    //     console.log()
    //     if (mine === 'mine') {
    //         set_mine('all');
    //         return;
    //     }
    //     if (authenticated) {
    //         set_mine('mine');
    //         return;
    //     }
    //     Swal.fire('You Must Login to view your dashboards');
    // };

    const getDashboards = useCallback(() => {
        if (email && mine === 'mine') {
            dispatch(getDashboardsBySite(site, email));
        } else {
            dispatch(getDashboardsBySite(site, debouncedSearchTerm));
        }
    }, [email, mine, site, debouncedSearchTerm, dispatch]);

    const sortDashboards = (dashboards) => {
        let sortedDashboards = dashboards.sort((a, b) => {
            let fa = a.dashboardId.toLowerCase();
            let fb = b.dashboardId.toLowerCase();
            if (fa < fb) return -1;
            if (fa > fb) return 1;
            return 0;
        });

        return sortedDashboards;
    };

    const setSite = (siteId) => {
        localStorage.setItem(previousSelectedSiteIdKey, siteId);
        set_site(siteId);
    };

    useEffect(() => {
        const localStorageSearchTerm = localStorage.getItem(previousSearchTermKey);
        if (localStorageSearchTerm) {
            previousSearchTerm.current = localStorageSearchTerm;
        }
    }, []);

    useEffect(() => {
        if (siteIds) {
            const previousSelectedSiteId = localStorage.getItem(previousSelectedSiteIdKey);
            if (previousSelectedSiteId && siteIds.includes(previousSelectedSiteId)) {
                set_site(previousSelectedSiteId);
            } else {
                set_site(siteIds[0]);
            }
        }
    }, [siteIds]);

    useEffect(() => {
        if (dashboard.gettingDashboardsForSiteSuccess) {
            setDashboards(sortDashboards(dashboard.dashboards));
            dispatch(resetGettingDashboardsBySite());
        }
    }, [dashboard.gettingDashboardsForSiteSuccess, dashboard.dashboards, dispatch]);

    useEffect(() => {
        localStorage.setItem(previousSearchTermKey, debouncedSearchTerm);
        if (authenticated && site) {
            if (previousSearchTerm.current) {
                setSearchTerm(previousSearchTerm.current);
                previousSearchTerm.current = '';
            } else {
                getDashboards();
            }
        }
    }, [site, authenticated, email, mine, dispatch, debouncedSearchTerm, getDashboards]);

    //on load mark favorited dashboards that are under my dashboards
    useEffect(() => {
        if (dashboard.dashboards.length > 0 && !favoriteDashboardsLoading) {
            for (let x = 0; x < favoriteDashboards.length; x++) {
                for (let y = 0; y < dashboard.dashboards.length; y++) {
                    if (dashboard.dashboards[y].dashboardId === favoriteDashboards[x].dashboardId) {
                        setFavorite(y, true);
                        break;
                    }
                }
            }
        }
    }, [dispatch, dashboard, favoriteDashboards, favoriteDashboardsLoading]);

    return (
        <div className='page-container'>
            {siteIdsLoading ? (
                <>
                    <AppLoader containerStyle={{ minHeight: '50vh' }} />
                </>
            ) : (
                <>
                    <Typography variant='h4'>Search Dashboards</Typography>

                    <div className='browse-actions' style={{ display: 'flex' }}>
                        <FormControl style={{ marginRight: '10px' }}>
                            <InputLabel>Site</InputLabel>
                            <Select native value={site} onChange={(e) => setSite(e.target.value)} style={{ width: '100%' }}>
                                {siteIds.map((site, key) => {
                                    return (
                                        <option key={key} value={site}>
                                            {site}
                                        </option>
                                    );
                                })}
                            </Select>
                        </FormControl>
                        <FormControl>
                            <TextField
                                id='search'
                                type='text'
                                value={searchTerm}
                                placeholder='Search'
                                autoComplete='off'
                                className={classes.searchRoot}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position='start'>
                                            <SearchIcon></SearchIcon>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </FormControl>

                        {/* <Toggle label='Filter'>
                        <Toggle.Item id='toggle-1' key='toggle-1' name='example' value={false} onChange={handleToggle} checked={!mine}>
                            All
                        </Toggle.Item>
                        <Toggle.Item id='toggle-2' key='toggle-2' name='example' value={true} onChange={handleToggle} checked={mine}>
                            Mine
                        </Toggle.Item>
                    </Toggle> */}
                    </div>

                    <TableContainer component={Paper}>
                        <Table className='dashboards-table' aria-label='simple table'>
                            <TableHead>
                                {isMobile ? (
                                    <StyledTableRow>
                                        <StyledTableCell>Dashboards</StyledTableCell>
                                    </StyledTableRow>
                                ) : (
                                    <StyledTableRow>
                                        <StyledTableCell align='left'>Favorite</StyledTableCell>
                                        <StyledTableCell>Dashboard Name</StyledTableCell>
                                        <StyledTableCell style={{ paddingLeft: '0px' }}>Owner</StyledTableCell>
                                        <StyledTableCell align='right'>Hits</StyledTableCell>
                                    </StyledTableRow>
                                )}
                            </TableHead>
                            <TableBody>
                                {dashboards.length < 1 ? (
                                    <StyledTableRow>
                                        <StyledTableCell className='temp-cell' colSpan='4'>
                                            {dashboard.gettingDashboardsForSite ? (
                                                <AppLoader containerStyle={{ margin: '30px 0px' }} />
                                            ) : (
                                                <div className='temp-cell'>No Dashboards Found</div>
                                            )}
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ) : (
                                    <>
                                        {dashboard.gettingDashboardsForSite ? (
                                            <StyledTableRow>
                                                <StyledTableCell className='temp-cell' colSpan='4'>
                                                    <AppLoader containerStyle={{ margin: '30px 0px' }} />
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ) : (
                                            dashboards.map((dashboard, key) => {
                                                return isMobile ? (
                                                    <StyledTableRow
                                                        key={key}
                                                        onClick={() => openDashboard(dashboard)}
                                                    >
                                                        <StyledTableCell>
                                                            <h3>
                                                                {dashboard.name || ''}
                                                                <span>
                                                                    {dashboard.favorite ? (
                                                                        <FavoriteIcon
                                                                            color='secondary'
                                                                            className='favIconMobile'
                                                                            ref={(ref) => {
                                                                                if (!ref) return;
                                                                                ref.onclick = (e) => {
                                                                                    e.stopPropagation();
                                                                                    handleUpdateFavoriteDashboard(key, !dashboard.favorite);
                                                                                };
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <FavoriteBorderOutlinedIcon
                                                                            className='favIconMobile'
                                                                            ref={(ref) => {
                                                                                if (!ref) return;
                                                                                ref.onclick = (e) => {
                                                                                    e.stopPropagation();
                                                                                    handleUpdateFavoriteDashboard(key, !dashboard.favorite);
                                                                                };
                                                                            }}
                                                                        />
                                                                    )}
                                                                </span>
                                                            </h3>
                                                            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                <span style={{ paddingRight: '5px' }}>Owner: </span>
                                                                {dashboard.owner === userName ? (
                                                                    <Tooltip title='Owner'>
                                                                        <PersonIcon></PersonIcon>
                                                                    </Tooltip>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                                {dashboard.contributors.map((contributor) => {
                                                                    if (contributor.email === email) {
                                                                        return (
                                                                            <Tooltip key={email} title='Contributor'>
                                                                                <PeopleIcon></PeopleIcon>
                                                                            </Tooltip>
                                                                        );
                                                                    } else {
                                                                        return null;
                                                                    }
                                                                })}
                                                                <span style={{ paddingLeft: '5px' }}>{dashboard.owner || ''}</span>
                                                            </div>
                                                            <div>Hits: {dashboard.hits || 0}</div>
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                ) : (
                                                    <StyledTableRow
                                                        key={key}
                                                        onClick={() => openDashboard(dashboard)}
                                                    >
                                                        <StyledTableCell align='left'>
                                                            {dashboard.favorite ? (
                                                                <FavoriteIcon
                                                                    color='secondary'
                                                                    className='favIcon'
                                                                    ref={(ref) => {
                                                                        if (!ref) return;
                                                                        ref.onclick = (e) => {
                                                                            e.stopPropagation();
                                                                            handleUpdateFavoriteDashboard(key, !dashboard.favorite);
                                                                        };
                                                                    }}
                                                                />
                                                            ) : (
                                                                <FavoriteBorderOutlinedIcon
                                                                    className='favIcon'
                                                                    ref={(ref) => {
                                                                        if (!ref) return;
                                                                        ref.onclick = (e) => {
                                                                            e.stopPropagation();
                                                                            handleUpdateFavoriteDashboard(key, !dashboard.favorite);
                                                                        };
                                                                    }}
                                                                />
                                                            )}
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                {dashboard.name || ''}
                                                                {dashboard.owner === userName ? (
                                                                    <Tooltip title='Owner'>
                                                                        <PersonIcon></PersonIcon>
                                                                    </Tooltip>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                                {dashboard.contributors.map((contributor) => {
                                                                    if (contributor.email === email) {
                                                                        return (
                                                                            <Tooltip key={email} title='Contributor'>
                                                                                <PeopleIcon></PeopleIcon>
                                                                            </Tooltip>
                                                                        );
                                                                    } else {
                                                                        return null;
                                                                    }
                                                                })}
                                                            </div>
                                                        </StyledTableCell>
                                                        <StyledTableCell style={{ paddingLeft: '0px' }}>{dashboard.owner || ''}</StyledTableCell>
                                                        <StyledTableCell align='right'>{dashboard.hits || 0}</StyledTableCell>
                                                    </StyledTableRow>
                                                );
                                            })
                                        )}
                                    </>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            )}
        </div>
    );
};

export default Browse;
